import { makeAutoObservable } from 'mobx'
import { User } from 'models/user'
import { UsersApi } from 'services/api/UsersApi'

export class UserStore {
  user: User | null = null

  constructor() {
    makeAutoObservable(this)
  }
  get isAuth() {
    return !!this.user
  }
  setUser(user: User | null) {
    this.user = user
  }

  getUser() {
    return UsersApi.getMe().then(({ data }) => {
      this.setUser(data)
    })
  }
}
